import { APP } from 'src/Configs/App'
import { campaignsList, login } from 'src/Router/routes'
import { getClientId, getGaSession } from 'src/Redux/analyticsApi/helpers'

import { persistPendingReferralCodes } from './pendingReferralCodes'
import {
  PendingCampaignData,
  persistPendingCampaignData,
} from './pendingCampaignData'
import { persistPendingGoogleAuth } from './pendingGoogleAuth'
import { persistPendingGoogleSignupSurvey } from './pendingGoogleSignupSurvey'

export interface InitiateGoogleAuthParams {
  internalReferralCode?: string
  referralCode?: string
  campaignData?: PendingCampaignData
  isSignUp?: boolean
}

export const initiateGoogleAuth = ({
  internalReferralCode,
  referralCode,
  campaignData,
  isSignUp,
}: InitiateGoogleAuthParams): void => {
  persistPendingReferralCodes({ internalReferralCode, referralCode })
  persistPendingGoogleAuth()
  if (campaignData) {
    persistPendingCampaignData(campaignData)
  }
  if (isSignUp && !campaignData) {
    persistPendingGoogleSignupSurvey()
  }

  const successUrl = `${window.location.origin}${campaignsList}`
  const cancelUrl = `${window.location.origin}${login}`
  const clientId = getClientId()
  const gaSession = getGaSession()
  const analyticsParams: Record<string, string> = {}
  if (clientId) {
    analyticsParams.clientId = clientId
  }
  if (gaSession) {
    analyticsParams.gaSession = gaSession
  }
  const params = new URLSearchParams({
    successUrl,
    cancelUrl,
    ...analyticsParams,
  })

  window.location.href = `${APP.TIKTOK_SERVER}/public/auth/google?${params.toString()}`
}
